import { render, staticRenderFns } from "./DistributionTile.vue?vue&type=template&id=4037d318&"
import script from "./DistributionTile.vue?vue&type=script&lang=js&"
export * from "./DistributionTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports